import {
  Component,
  EventEmitter,
  inject,
  Inject,
  Input,
  Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { ModalFilterComponent } from '../../modals/modal-filter/modal-filter.component';
import { NgOptimizedImage } from '@angular/common';

export interface FilterOption {
  id: string;
  label: string;
  options: { value: string; label: string }[];
}

export interface AppliedFilter {
  filterId: string;
  filterLabel: string;
  value: string;
  label: string;
}

@Component({
  selector: 'app-filters',
  imports: [NgOptimizedImage],
  templateUrl: './filters.component.html',
  standalone: true,
  styleUrl: './filters.component.scss',
})
export class FiltersComponent {
  @Input() title: string = '';
  @Input() filterOptions: FilterOption[] = [];
  @Input() appliedFilters: AppliedFilter[] = [];
  @Output() filtersChanged = new EventEmitter<AppliedFilter[]>();
  @Input() useQueryParams: boolean = false;
  private dialog = inject(MatDialog);

  openFilterModal(): void {
    const dialogRef = this.dialog.open(ModalFilterComponent, {
      width: '100%',
      data: {
        filterOptions: this.filterOptions,
        appliedFilters: [...this.appliedFilters],
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.appliedFilters = result;
        this.filtersChanged.emit(this.appliedFilters);
      }
    });
  }

  removeFilter(filter: AppliedFilter): void {
    this.appliedFilters = this.appliedFilters.filter(
      (f) => !(f.filterId === filter.filterId && f.value === filter.value),
    );
    this.filtersChanged.emit(this.appliedFilters);
  }
}
